import { PagesStateInterface } from './initialState.interface';

export const pagesInitialState: PagesStateInterface = {
  page: {},
  loading: false,
};
